import React from 'react';
import AccidentsInputComponent from './AccidentsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const AccidentsInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <AccidentsInputComponent question={question} />;
  }
};

export default AccidentsInputPicker;
